import {  ChartLoading, TaskSummaryChart } from "@vericus/cadmus-common";

import { useIssueSummaryInsights } from "../api/use-issue-summary-insights";
import * as styles from "./issue-summary-chart.css"
import { UserFragment } from "@/generated/graphql";
import { Text } from "@vericus/cadmus-ui";
  
interface Props {
  assessmentId: string;
  workId: string;
  studentIds: string[];
  users: UserFragment[];
}

/**
 * Chart to summaries Issues as Project Management Tasks across groups
 */
export function IssueSummaryChart(props: Props) {
  const { data, isFetching } = useIssueSummaryInsights(
    props.assessmentId,
    props.workId,
    props.studentIds
  );

  if(isFetching) return <ChartLoading />

  if (!data || data.length === 0) {
    return (
      <div className={styles.emptyContainer}>
        <Text color="grey300" kind="bodyLg" textAlign="center">
          No data available
        </Text>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <TaskSummaryChart xAxisKey="user_id" data={data} list={props.users} />
    </div>
  );
}
